import React from 'react';
import { Link } from 'react-router-dom';
import { Activity } from 'lucide-react';
import Header from '@/components/Header';

export default function Impressum() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="container mx-auto px-4 py-12 max-w-4xl" role="main">
        <nav aria-label="Breadcrumb" className="mb-8">
          <Link 
            to="/" 
            className="inline-flex items-center text-primary hover:text-primary-hover transition-colors text-sm font-medium mb-6"
          >
            ← Zurück zum Anamnese Generator
          </Link>
        </nav>

        <div className="bg-card border border-border rounded-lg shadow-sm p-8 md:p-12">
          <div className="flex items-center gap-3 mb-8">
            <div className="p-2 bg-primary/10 rounded-lg">
              <Activity className="w-6 h-6 text-primary" />
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-foreground">Impressum</h1>
          </div>

          <div className="prose prose-slate max-w-none">
            <div className="space-y-6 text-foreground">
              <div>
                <p className="text-lg leading-relaxed">
                  Jonas Parlow c/o Block Services<br />
                  Stuttgarter Str. 106<br />
                  70736 Fellbach
                </p>
              </div>

              <div className="pt-4 border-t border-border">
                <h2 className="text-2xl font-semibold text-foreground mb-4">Kontakt</h2>
                <p className="text-lg leading-relaxed">
                  Telefon: <a href="tel:01759926145" className="text-primary hover:text-primary-hover">0175 9926145</a><br />
                  E-Mail: <a href="mailto:info@creativey.media" className="text-primary hover:text-primary-hover">info@creativey.media</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="mt-16 py-8 border-t border-border">
        <div className="container mx-auto px-4 text-center">
          <div className="flex flex-wrap justify-center gap-4 text-sm text-muted-foreground mb-4">
            <Link to="/impressum" className="hover:text-primary transition-colors">
              Impressum
            </Link>
            <span>•</span>
            <Link to="/datenschutz" className="hover:text-primary transition-colors">
              Datenschutz
            </Link>
          </div>
          <p className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} Creativey Media
          </p>
        </div>
      </footer>
    </div>
  );
}
